import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useRef, useState } from 'react';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelMovement from '../../../../../components/extras/SidePanelMovement';
import SelectUser from '../../../../../components/selects/selectUser';
import TableMovements from '../../../../../components/tables/tableMovements';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemsMovement } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;



export const AdminMovementsUserPage = () => {
    const { data, menu, parameters } = useGlobalState();
    //const storeAdmin = useStoreAdmin();


    const [movements, setMovements] = useState<ItemsMovement[]>([]);
    const [movement, setMovement] = useState<Partial<ItemsMovement>>({});


    //const [idUser, setIdUser] = useState(0);

    type ItemConecpt = {
        value: string;
        label: string;
    };

    type ChargesItem = {
        idCharge: number,
        ammount: number,
        currency: string,
        charge: string,
        accountPlan: string,
    };
    type GroupsItems = {
        idGroup: number,
        group: string,
    };
    const conceptItems: ItemConecpt[] = [
        { label: "DEPÓSITO DIRECTO", value: "DEPÓSITO DIRECTO" },
        { label: "TRANSFERENCIA ELECTRÓNICA", value: "TRANSFERENCIA ELECTRÓNICA" },
        { label: "CHEQUE", value: "CHEQUE" },
        { label: "TRANSBANK DEBITO", value: "TRANSBANK DEBITO" },
        { label: "TRANSBANK CREDITO", value: "TRANSBANK CREDITO" },
        { label: "EFECTIVO CLP", value: "EFECTIVO CLP" },
        { label: "EFECTIVO USD", value: "EFECTIVO USD" },
        { label: "EFECTIVO EUR", value: "EFECTIVO EUR" },
        { label: "OTRO", value: "" }
    ]

    const mountedRef = useRef(false);
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id) {
                if (!mountedRef.current) {
                    mountedRef.current = true;
                    handleRefreshMovements()
                }
                setMovement(undefined)
                handleGetMovenent(parseInt(id))
            } else {
                setMovement(undefined)
                handleRefreshMovements();
            }
        };
        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);
    useEffect(() => {
        handleRefreshMovements();
    }, [parameters.startDate, parameters.endDate, parameters.idUser]);

    useEffect(() => {

    }, [parameters]);

    const params = new URLSearchParams(window.location.hash.split('?')[1]);
    useEffect(() => {
        if (params.get('startDate') && params.get('startDate') !== undefined && params.get('startDate') !== null && params.get('startDate') !== "") {
            setParameters((prev: any) => ({ ...prev, startDate: params.get('startDate') }));
        }
        if (params.get('endDate') && params.get('endDate') !== undefined && params.get('endDate') !== null && params.get('endDate') !== "") {
            setParameters((prev: any) => ({ ...prev, endDate: params.get('endDate') }));
        }
        if (params.get('idUser')) {
            setParameters((prev: any) => ({ ...prev, idUser: params.get('idUser') }));
        }
    }, []);

    const handleGetMovenent = async (id: number) => {
        if (parameters.startDate && parameters.endDate) {
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/movement',
                        'JWT': getCookie("JWT"),
                    },
                    body: JSON.stringify({
                        idUser: parameters.idUser,
                        idMovement: id,
                        columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,obs,dateTransaction,displayName,idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK, idFlight, tbkCodAuto"
                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    setMovement(data.movement);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }

        };
    }
    const handleRefreshMovements = async () => {
        if (parameters.startDate && parameters.endDate && parameters.idUser && parameters.idUser > 0) {
            try {
                setMovements([])
                setMovement(undefined)
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        dateStart: parameters.startDate,
                        dateEnd: parameters.endDate,
                        idUser: parameters.idUser,
                        orderBy: "dateTransaction",
                        order: "desc",
                        orderBy2: "idMovement",
                        order2: "desc",
                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    setMovements(data.movements);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }

        };
    }
    type Value = {
        type: "absolute" | "relative";
        startDate?: string;
        endDate?: string;
        key?: string;
        amount?: number;
        unit?: string;
    };



    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={!!movement}
            onSplitPanelToggle={({ detail }) => !detail.open ? window.location.hash = "#admin/movements/user" : null}
            splitPanel={movement && (
                <SidePanelMovement movement={movement ?? {}} />
            )}
            contentType="form"
            breadcrumbs={
                < BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">

                        <Header
                            actions={<Favorites />}>
                            Movimientos de usuario



                        </Header>

                        <SpaceBetween direction="horizontal" size="xs">

                            <SelectUser value={parameters.idUser} onConfirm={(user) => {
                                const updatedParameters = { ...parameters, idUser: user?.idUser || 0 };
                                setParameters(updatedParameters);
                                if (!user)
                                    window.location.hash = "#admin/movements/user"
                            }} />

                        </SpaceBetween>

                        {parameters.idUser > 0 && (
                            <SpaceBetween direction='vertical' size='xs'>
                                <TableMovements excel showBalances showBalance showUser={false} key={"kMovements"}
                                    dateFilter="RANGE"
                                    onRefresh={() => handleRefreshMovements()}
                                    onSelect={(row: ItemsMovement) => {

                                        window.location.hash = `#admin/movements/user?id=${row.idMovement}`

                                    }} movements={movements} visible={true}
                                    onRangeChange={(startDate, endDate) => {
                                        const updatedParameters = { ...parameters, startDate: startDate, endDate: endDate, };
                                        setParameters(updatedParameters);

                                    }}
                                />

                            </SpaceBetween>
                        )}

                    </SpaceBetween>



                </>
            }
        />
    );
};
